import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.50188 9.95906L4.24188 6.69906C3.85687 6.31406 3.85687 5.68406 4.24188 5.29906L7.50188 2.03906",
		stroke: "#8E68F7",
		strokeWidth: 1.5,
		strokeMiterlimit: 10,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowLeft;
